import React from "react";

const CookiesSummarySnippet = () => (
  <p>
    Nous utilisons des cookies indispensables et des technologies similaires
    pour assurer le bon fonctionnement du UNBL. Nous souhaitons également nous
    en servir pour orienter nos améliorations, en enregistrant la manière dont
    vous utilisez le site. Ceux-ci ne seront installés que si vous donnez votre
    accord.
  </p>
);

export default CookiesSummarySnippet;
